import { useNullableContext } from '~/common/contexts/nullableContext';
import { AuthApiContext } from '../../AuthApiContext';
import { AuthApi } from '../../types';

export const useAuthApi = (): AuthApi =>
  useNullableContext(
    AuthApiContext,
    'useAuthApi must be used within an AuthProvider',
  );
